import React from "react";
import "../OpalAccountInfoDetails.css";

const OpalAccountAddressDetails = ({ data }) => {
    return (
        <div className="opal-info-details">
            <div className="opal-row">
                <div className="opal-cell label">Region</div>
                <div className="opal-cell value">{data?.region?.description}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Province</div>
                <div className="opal-cell value">{data?.province?.description}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">City</div>
                <div className="opal-cell value">{data?.city?.description}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Barangay</div>
                <div className="opal-cell value">{data?.locality?.description}</div>
            </div>
            <div className="opal-row">
                <div className="opal-cell label">Full Address</div>
                <div className="opal-cell value">{data?.fullAddress}</div>
            </div>
        </div>
    );
};

export default OpalAccountAddressDetails;
